import { clsx as o } from "clsx";
import { twMerge as t } from "tailwind-merge";
function n(...r) {
  return t(o(r));
}
export {
  n as cn
};
